export const AUTH_TOKEN_KEY = "geoAppToken_v2";
export const AUTH_SESSION_HINT_KEY = "geoAppSession_v1";
export const CSRF_TOKEN_KEY = "geoAppCsrf_v1";
export const USER_STORAGE_KEY = "geoAppUser_v2";
export const PROJECT_STORAGE_KEY = "geoAppSelectedProject_v2";
export const PROJECTS_LIST_PREFIX = "geoAppProjectsList_v3_";
export const PROJECT_DATA_PREFIX = "geoAppData_v3_";
export const TEMPLATE_PREFIX = "geoAppTemplate_v3_";
export const SYNC_QUEUE_PREFIX = "geoAppSyncQueue_v3_";
export const SYNC_CONFLICT_PREFIX = "geoAppSyncConflict_v3_";

export const LEGACY_PROJECTS_LIST_KEY = "geoAppProjectsList_v2";
export const LEGACY_PROJECT_DATA_PREFIX = "geoAppData_v2_";
export const LEGACY_TEMPLATE_PREFIX = "geoAppTemplate_v2_";
export const LEGACY_SYNC_QUEUE_PREFIX = "geoAppSyncQueue_v2_";
export const LEGACY_SYNC_CONFLICT_PREFIX = "geoAppSyncConflict_v2_";

function scopedPart(value) {
  return encodeURIComponent(String(value || "anonymous"));
}

export function getProjectsListKey(userId) {
  return `${PROJECTS_LIST_PREFIX}${scopedPart(userId)}`;
}

export function getProjectDataKey(userId, projectId) {
  return `${PROJECT_DATA_PREFIX}${scopedPart(userId)}_${scopedPart(projectId)}`;
}

export function getTemplateKey(userId, projectId) {
  return `${TEMPLATE_PREFIX}${scopedPart(userId)}_${scopedPart(projectId)}`;
}

export function getSyncQueuePrefix(userId) {
  return `${SYNC_QUEUE_PREFIX}${scopedPart(userId)}_`;
}

export function getSyncQueueKey(userId, projectId) {
  return `${getSyncQueuePrefix(userId)}${scopedPart(projectId)}`;
}

export function getSyncConflictKey(userId, projectId) {
  return `${SYNC_CONFLICT_PREFIX}${scopedPart(userId)}_${scopedPart(projectId)}`;
}

export function getLegacyProjectDataKey(projectId) {
  return `${LEGACY_PROJECT_DATA_PREFIX}${projectId}`;
}

export function getLegacyTemplateKey(projectId) {
  return `${LEGACY_TEMPLATE_PREFIX}${projectId}`;
}

export function getLegacySyncQueueKey(projectId) {
  return `${LEGACY_SYNC_QUEUE_PREFIX}${projectId}`;
}

export function getLegacySyncConflictKey(projectId) {
  return `${LEGACY_SYNC_CONFLICT_PREFIX}${projectId}`;
}
